// ギフティング画面の使い方ヘルプ。正本は stoq-ad/docs/gifting-console-guide.md（内容を一致させる）。
import { GfButton, GfModal } from "../ui/GfUi";

export function HelpModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <GfModal
      open={open}
      title="ギフティング画面の使い方"
      onClose={onClose}
      width={640}
      footer={
        <GfButton variant="primary" onClick={onClose}>
          閉じる
        </GfButton>
      }
    >
      <div className="gf-help">
        <div className="gf-help-h">1. このツールでできること</div>
        <p className="gf-help-p">
          インフルエンサー・クリエイターへの商品提供（無償ギフト・有償依頼・アフィリエイト付き）を1か所で管理します。「誰に何を送ったか」「投稿してくれたか」「報酬は支払ったか」が迷子にならないようにするのが目的です。
        </p>
        <ul className="gf-help-ul">
          <li>相手に渡すのは「本人入力フォームのURL」だけ。相手はログイン不要で、住所の入力や投稿の報告をします。</li>
          <li>この画面を使う人は、案件を作り、DMで連絡し、発送し、投稿を確認します。</li>
        </ul>

        <div className="gf-help-h">2. 全体の流れ（段階）</div>
        <p className="gf-help-p">1件の依頼（エントリー）は次の段階で進みます。多くの切り替えはボタン1つで進められます。</p>
        <ul className="gf-help-ul">
          <li>1 打診中 … 声かけの準備・最初の打診</li>
          <li>2 返信待ち … 打診済み。返事を待つ</li>
          <li>3 条件合意 … 条件が決まった。住所フォームを送る段階</li>
          <li>4 住所回収 … 本人が住所を入力するのを待つ → 入力されたら発送へ</li>
          <li>5 発送済 … 追跡番号を入れて発送。投稿を待つ</li>
          <li>6 投稿確認 … 投稿が出たら内容とPR表記を確認する</li>
          <li>7 2次利用許諾 … 投稿素材を商品ページ等に使う許可を記録する（案件で「2次利用なし」の場合は省略され、6の次にアーカイブ）</li>
          <li>8 アーカイブ … 完了。一覧から外れる</li>
        </ul>
        <p className="gf-help-p">
          営業リスト上の候補は「0 リスト化」の扱いで、案件に追加すると「打診中」から始まります。相手がフォームで住所を送ると「住所受領」に、投稿を報告すると「投稿確認」へ自動で進みます（案件タブ上部の「自動更新」バーに出ます）。
        </p>

        <div className="gf-help-h">3. 画面の見かた（8つのタブ）</div>
        <ul className="gf-help-ul">
          <li>ダッシュボード … 進行中の件数、今月の発送、アフィリ経由売上（Shopify）、今月の支払予定、要対応の一覧（「検知した投稿の確認」も出ます）。</li>
          <li>案件 … メインの作業画面。カンバン（交渉中／配送中／投稿・許諾）・一覧・アーカイブを切り替え。「クリエイターを追加」「新規案件」もここ。カードをクリックすると詳細パネルが開きます。</li>
          <li>クリエイター … 名簿。SNS・ジャンル・個別料率・口座の状態を確認・編集。過去の参加案件も見られます。</li>
          <li>発送 … 住所回収中〜発送済みの一覧。フォームURLの確認・コピーと、本人に代わっての住所入力（貼り付けると郵便番号・住所・電話を自動で分けます）。</li>
          <li>報酬・料率 … 案件タイプ（無償／有償／無償＋アフィリ／有償＋アフィリ）、固定報酬、基本料率、個別料率、アフィリ登録。試算は想定値です。</li>
          <li>素材庫 … 2次利用の許諾を記録した投稿素材の一覧（媒体・用途・期限）。上部の「検知した投稿」に、Instagram で自動検知したあと案件に紐づいていない投稿が出ます（9章）。</li>
          <li>営業 … 候補リスト。チェックして「案件に追加（打診中）」。AI提案・一括DM・営業資料は未接続です。</li>
          <li>精算・連携 … 連携状況（Shopify・楽天・Amazon・倉庫出荷・Instagram 投稿検知）と、月ごとの支払予定・口座状態。照合用CSVを出力できます。</li>
        </ul>
        <p className="gf-help-p">上の検索ボックスで、クリエイター名・ハンドル・案件名・受注番号・商品名から探せます。</p>

        <div className="gf-help-h">4. 要対応と詳細パネル</div>
        <p className="gf-help-p">カードに出るラベルが「いま動くべきこと」です。</p>
        <ul className="gf-help-ul">
          <li>打診する（段階1）／条件を確定（段階3）／投稿を確認（段階6）／許諾を記録（段階7）は常に要対応</li>
          <li>催促 … 返信待ちで4日以上たったとき</li>
          <li>住所を催促 … 住所待ちで3日以上たったとき</li>
          <li>発送する … 住所が届いたとき</li>
          <li>投稿を催促 … 発送後、投稿期限を過ぎたとき</li>
        </ul>
        <p className="gf-help-p">
          詳細パネルの下部の主ボタンに、次にやることが書かれています。「⋯」メニューには、催促した（記録）／段階を戻す・修正／中止にする があります。
        </p>
        <ul className="gf-help-ul">
          <li>進み具合（7段階のバー）と履歴（日付・出所: 手動／本人フォーム／Instagram API など）</li>
          <li>本人入力フォーム … URLのコピー・再発行・無効化</li>
          <li>出荷 … 住所が届いたら「出荷指示を送る」で倉庫へ0円出荷指示（追跡番号は倉庫の出荷後に自動で入ります）。手入力で「発送済みにする」こともできます</li>
          <li>投稿・2次利用 … 投稿URLの記録、確認、PR表記の確認、2次利用の用途と期限</li>
          <li>計測リンク … 案件ごとに発行。クリック数は累計と直近7日</li>
          <li>報酬（有償） … 報酬額・支払予定月・支払状態・請求書</li>
          <li>メモ</li>
        </ul>

        <div className="gf-help-h">5. メッセージ（DM）</div>
        <p className="gf-help-p">詳細パネル下部の「DM」ボタン（Instagram未連携の人は「メッセージ」）から開きます。</p>
        <ul className="gf-help-ul">
          <li>Instagram連携済みのクリエイター … DM履歴（直近30件）を表示。テンプレートを挿入して編集し、このアプリから送信できます。送信前に確認が出ます。1000字まで。送信すると「最終連絡日」が更新され、打診中なら返信待ちへ進みます。</li>
          <li>未連携のクリエイター … テンプレートに情報を差し込んだ文面ができるので、コピーして Instagram アプリなどに貼って送ります。</li>
        </ul>
        <p className="gf-help-p">テンプレートに書くと自動で置き換わる言葉:</p>
        <ul className="gf-help-ul">
          <li>{"{名前}"} … 相手の名前</li>
          <li>{"{商品}"} … 送る商品名</li>
          <li>{"{フォームURL}"} … その依頼の本人入力フォームのURL</li>
          <li>{"{期限}"} … 投稿期限</li>
        </ul>
        <p className="gf-help-p">DMテンプレートは、ヘッダ右「その他」→「DMテンプレート」で作成・編集・削除できます。</p>

        <div className="gf-help-h">6. Instagram連携</div>
        <ul className="gf-help-ul">
          <li>「クリエイターを追加」→「Instagramから選ぶ」 … 最近DMした人、または検索から選ぶとワンタップで登録できます。任意で案件を選ぶと、開始する段階（打診中／返信待ち／条件合意）を選んでそのまま案件に追加できます。すでに登録済みの相手を選んだときは既存のクリエイターが使われます。</li>
          <li>クリエイター詳細の「Instagram連携」 … 登録済みの人に、DMでやり取りした相手を検索して紐付けます。連携するとDM履歴の表示と送信が使えます。</li>
          <li>YouTube・TikTok だけの人は連携なしの通常登録で使えます（DM機能以外は同じです）。</li>
        </ul>

        <div className="gf-help-h">7. 発送と住所</div>
        <ul className="gf-help-ul">
          <li>条件が決まったら、段階3の主ボタン「住所フォームを送る」を押します（確認ダイアログでフォームURLをコピーできます）。</li>
          <li>DMでフォームURLを送ります。案件の「送る商品」が「クリエイターが選ぶ」なら、相手はフォームでセットを1つ選んでから住所を入力します（選んだセットが出荷指示に入ります。代理入力ではこちらで選べます）。入力されると、住所が届いた状態になります。</li>
          <li>住所が届くと、出荷内容（SKU・郵便番号・電話）が自動でチェックされます。詳細パネルの「出荷指示を送る」を押すと、宛先と商品を確認したうえで倉庫へ0円の出荷指示が送られます（受注番号 INF-… が付きます）。</li>
          <li>相手が入力できない場合は、発送タブの代理入力で本人に代わって入力できます。</li>
        </ul>
        <p className="gf-help-p">倉庫が出荷すると、毎日17時台〜22時台に追跡番号が自動で取り込まれ「発送済」に進みます（発送タブの「今すぐ同期」でも取り込めます）。出荷指示を送ったあとは本人フォームから住所を変えられないので、変更はDMで受けて倉庫へ連絡してください。チェックで「住所を修正」と出たときは、発送タブの代理入力で直します。</p>
        <p className="gf-help-p">出荷指示は cs.nayu.site の「出荷指示」画面から出しても構いません（「🎁 ギフティングから選択」で住所が届いた案件を選べます）。どちらで出しても同じ案件の2回目は止まり（二重出荷しない）、倉庫の出荷報告で追跡番号がこの画面に戻って「発送済」に進みます。段階が進むのは「出荷指示を出した時」ではなく「倉庫が出荷報告した時」です。</p>

        <div className="gf-help-h">8. 投稿確認と2次利用</div>
        <ul className="gf-help-ul">
          <li>投稿URLを記録します（相手がフォームから報告すると自動で入ります。写真に @stoq_kitchen をタグ付けした投稿は Instagram から自動で入ります。9章）。</li>
          <li>実際の投稿を見て、PR／タイアップ表記があるかを必ず確認します（景品表示法のステルスマーケティング規制）。段階6から先へ進むときは、確認チェックがないと進めません。</li>
          <li>2次利用する場合は、相手の許可を取ったうえで、用途（広告・EC商品ページ・SNS・楽天LP・Shopify LP など）と期限を記録します。素材庫に集まります。期限の30日前から「期限間近」、過ぎると「期限切れ」と表示されます。</li>
        </ul>
        <p className="gf-help-p">2次利用の記録は「許可をもらった」ことの記録用です。許可を取らずに記録しないでください。</p>

        <div className="gf-help-h">9. 投稿の自動検知（Instagram）</div>
        <p className="gf-help-p">STOQの公式 Instagram（@stoq_kitchen）にタグ付けされた投稿を、1時間おきに自動で見つけて記録します。</p>
        <ul className="gf-help-ul">
          <li>対象は「写真（フィード・リール）に @stoq_kitchen をタグ付けした投稿」だけです。ストーリーズの @メンションや、キャプションに @stoq_kitchen と書いただけの投稿は自動では拾えません。これまでどおり、本人の報告（フォーム）かパネルの「＋ 投稿を追加」で記録してください。</li>
          <li>投稿者の Instagram ハンドルが登録済みクリエイターと一致し、その人の案件が「発送済」〜「2次利用許諾」にあると、投稿が自動で記録されます（「IG API で検知」のタグとサムネ付き）。「発送済」だった案件は「投稿確認」へ進みます。「投稿確認」「2次利用許諾」の人の追加投稿は、記録だけで段階は動きません。</li>
          <li>自動で記録したあとも、投稿の内容と PR 表記の確認は人が行います（段階6→7のチェックは必須のままです）。</li>
          <li>
            紐づけられなかった投稿は、素材庫の上部「検知した投稿」に出ます。クリエイター登録済みなら「案件に紐づける」（その人の「住所回収」〜「2次利用許諾」の案件から選びます）、未登録のアカウントなら「クリエイターとして追加」（営業の候補になります）、関係のない投稿は「無視」（「無視した投稿」からいつでも戻せます）。
          </li>
          <li>精算・連携タブの「Instagram 投稿検知」カードで、最終確認の時刻・直近のエラー・直近7日の自動記録数を確認できます。「今すぐ確認」を押すと、待たずに取り込めます。</li>
          <li>ダッシュボードの要対応に「検知した投稿の確認 n件」が出ます（クリエイター登録済みで、まだ案件に紐づいていないもの）。未登録アカウントの件数は、営業候補としてだけ表示されます。</li>
        </ul>

        <div className="gf-help-h">10. 2次利用の依頼DM（自動送信）</div>
        <p className="gf-help-p">案件の設定で、投稿確認のあとに2次利用のお願いを Instagram DM で自動送信できます（既定はOFF）。</p>
        <ul className="gf-help-ul">
          <li>設定場所: 「報酬・料率」タブの案件設定（2次利用の欄）、または「新規案件」。「投稿確認のあと、2次利用の依頼DMを自動で送る」をONにし、テンプレートを選びます（既定は「ご投稿のお礼」）。テンプレートは「その他」→「DMテンプレート」で編集できます。</li>
          <li>ONの案件で、段階6（投稿確認）→7（2次利用許諾）へ進めると、その直後にテンプレートが DM で送られます（確認ダイアログにも出ます）。送ると、許諾がまだの投稿は「申請中」になり、最終連絡日が更新されます。</li>
          <li>Instagram の仕様で、相手の最後のメッセージから24時間を過ぎると自動送信できません。Instagram と連携していないクリエイターにも送れません。送れなかったときも段階は戻りません。完了メッセージと履歴に結果が残るので、DM パネルから手動で依頼してください。</li>
          <li>「2次利用なし」の案件では使えません（投稿確認のあとそのままアーカイブされます）。</li>
          <li>自動で送るのは「依頼」だけです。許諾の記録（用途・期限）は、相手の返事を確認して人が行います。</li>
        </ul>

        <div className="gf-help-h">11. お金の管理</div>
        <ul className="gf-help-ul">
          <li>案件タイプで、固定報酬の有無とアフィリの有無が決まります。</li>
          <li>料率は、クリエイター別の個別料率があればそちら、なければ案件の基本料率が使われます。アフィリ未登録の人は成果が計上されないので、「報酬・料率」タブで登録します。</li>
          <li>有償の依頼は、パネルで報酬額・支払予定月・支払状態・請求書を管理します。</li>
          <li>「精算・連携」タブで月ごとの支払予定を確認し、「振込データ出力」で照合用CSVを出せます（全銀形式ではありません）。</li>
          <li>口座番号は下4桁のみ保存します。全桁は保存しません。インボイスは登録番号（T＋13桁）を記録します。</li>
        </ul>
        <p className="gf-help-p">このツールが管理するのは支払いの記録までです。実際の振込・会計処理は従来のやり方で行います。</p>

        <div className="gf-help-h">12. 注意事項</div>
        <ul className="gf-help-ul">
          <li>DMの実送信は取り消せません。相手に実際にメッセージが届きます。送信前の確認画面で宛先と本文を見直してください。</li>
          <li>PR表記の確認は必須です（景品表示法のステマ規制）。</li>
          <li>フォームURLは本人が入力するためのものです。再発行すると旧URLはすぐ使えなくなります。間違った相手に送った場合は「無効化」します。</li>
          <li>報酬額は本人入力フォームには表示されません。金額はDMで直接伝えてください。</li>
          <li>薬機法・景表法に触れる表現（効果の断定、No.1 などの根拠なき表現）を依頼文や投稿の指示に入れないでください。</li>
          <li>商品の仕様・形状・ロゴは変更せず、公式の素材と情報を渡してください。</li>
        </ul>

        <div className="gf-help-h">13. よくある質問</div>
        <ul className="gf-help-ul">
          <li>フォームURLをもう一度送りたい … 詳細パネルの「本人入力フォーム」でコピーします。</li>
          <li>住所を間違えて入力された … 発送前なら相手が同じURLから入力し直せます。こちらで直す場合は発送タブの代理入力を使います。</li>
          <li>返信が来た … 返信待ちのカードで、「⋯」→「返信あり・条件を確定へ進める」。</li>
          <li>段階を間違えた … 「⋯」→「段階を戻す／修正」。</li>
          <li>取りやめになった … 「⋯」→「中止にする」。</li>
          <li>ストーリーズで紹介してもらった／キャプションだけでメンションされた … 自動では拾えません。本人からの報告（フォーム）か、パネルの「＋ 投稿を追加」で記録します（9章）。</li>
          <li>自動DMが送れなかった … 24時間ルール（相手の最後のメッセージから24時間以内のみ送れます）か、Instagram 未連携が原因です。履歴を確認し、DM パネルから手動で送ってください（10章）。</li>
          <li>計測リンクのクリック数はどこ？ … 依頼ごとは詳細パネルの「計測リンク」、全体はヘッダ右「その他」→「計測リンクの成績」。Shopify はクーポンと売上まで紐付き、楽天・Amazon はクリック数のみです。</li>
        </ul>

        <div className="gf-help-h">14. ログインと権限</div>
        <ul className="gf-help-ul">
          <li>ログインはユーザー名とパスワード（管理者から発行されます）。cs.nayu.site のパスワードとは別です。画面左下に自分の名前と役割が出ます。ログアウトも左下です。</li>
          <li>役割は2つ。管理者は全画面、ギフティング担当はこの画面だけが表示されます（広告・P/L などの画面は出ず、直接 API を叩いても 403 で止まります）。</li>
          <li>ギフティング担当でできること: 案件・クリエイター・DM・住所・出荷指示・投稿確認・2次利用・アフィリ登録・料率編集・CSV出力。支払の確定（支払処理）は管理者のみです。</li>
          <li>ログインは12時間で切れます。切れたらログイン画面に戻るので、再度ログインしてください。</li>
          <li>パスワードを忘れた・変えたいときは管理者に連絡してください。</li>
        </ul>
      </div>
    </GfModal>
  );
}
